class IconlistComponent extends HTMLElement {
    constructor() {
      super();
      window.addEventListener('DOMContentLoaded', (event) => {
        this.initPages();
      });
    }
  
    initPages() {
        var section_id = this.dataset.section_id;
        if (this.classList.contains('type--slide')) {
          var main = new Splide( '#main-slider--'+section_id, {
            type   : 'loop',
            pagination : false,
            arrows     : true,
            cover      : false,

          });
          main.mount();
        } else if (window.innerWidth < 989) {

            var id = '#main-slider--'+section_id;
            var thumbnails = new Splide( id, {
                rewind          : true,
                fixedWidth      : '30%',
                gap             : 20,
                pagination      : false,
                arrows          : false,
                dragMinThreshold: {
                  mouse: 4,
                  touch: 10,
                },
            });
              
            thumbnails.mount();
        }
        
    }
  }
  
  customElements.define('icons-component', IconlistComponent);